<template>
    <div id="UserProfile">
        <Header :title="title" />

        <template v-if="app.template.type === '92fanli'">
            <main class="MainCon bottom0">
                <div class="mt10">
                    <div class="myContentBox_92fanli">
                        <div class="ml7 mr7">
                            <div class="flexBox flexBetween lh40 myborderB">
                                <div class="flexBox-cell-50 f10 lh48">头像</div>
                                <div class="flexBox-cell-50 tr infoHeadimg pt5"
                                     v-on:click="uploadAvatar">
                                    <img v-bind:src="userInfo.avatar"
                                         v-if="userInfo.avatar !== ''" />
                                </div>
                            </div>
                            <div class="flexBox flexBetween lh30 myborderB">
                                <div class="flexBox-cell-50 f10">用户名</div>
                                <div class="flexBox-cell-50 tr">
                                    <input type="text" class="infoInput"
                                           v-on:change='editNickname'
                                           v-model="userInfo.nickname" />
                                </div>
                            </div>
                            <div class="flexBox flexBetween lh30">
                                <div class="flexBox-cell-50 f10">手机号</div>
                                <div class="flexBox-cell-50 tr f10 color_999">{{userInfo.mobile}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt10">
                    <div class="myContentBox_92fanli">
                        <div class="ml7 mr7">
                            <div class="flexBox flexBetween lh30 myborderB"
                                 v-on:click='toEditPassword'>
                                <div class="flexBox-cell-50 f10">修改登录密码</div>
                                <div class="flexBox-cell-50 tr color_999 f8"><span
                                        class="iconfont icon-mjiantou-copy color_999"></span></div>
                            </div>
                            <div class="flexBox flexBetween myborderB lh30">
                                <div class="flexBox-cell-50 f10">支付宝绑定</div>
                                <div class="flexBox-cell-50 tr color_999 f8"
                                     v-show="isBindAliPay">已绑定<span
                                        class="iconfont icon-mjiantou-copy color_999"></span></div>
                                <div class="flexBox-cell-50 tr color_999 f8" v-show="!isBindAliPay"
                                     v-on:click='toBindAliPay()'>去绑定<span
                                        class="iconfont icon-mjiantou-copy color_999"></span></div>
                            </div>
                            <div class="flexBox flexBetween lh30">
                                <div class="flexBox-cell-50 f10">淘宝授权</div>
                                <div class="flexBox-cell-50 tr color_999 f8"
                                     v-show="isTopAuth">已授权<span
                                        class="iconfont icon-mjiantou-copy color_999"></span>
                                </div>
                                <div class="flexBox-cell-50 tr color_999 f8" v-show="!isTopAuth"
                                     v-on:click='toTopAuth'>去授权<span
                                        class="iconfont icon-mjiantou-copy color_999"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="myOutBtn_92fanli" v-on:click='logout'>退出登录</div>
            </main>
        </template>
        <template v-else-if="app.template.type === 'damai'">
            <main class="MainCon bottom0">
                <div class="ml10 mr10 mt10">
                    <div class="myContentBox">
                        <div class="ml7 mr7">
                            <div class="flexBox flexBetween lh40 myborderB">
                                <div class="flexBox-cell-50 f10 lh48">头像</div>
                                <div class="flexBox-cell-50 tr infoHeadimg pt5"
                                     v-on:click="uploadAvatar">
                                    <img v-bind:src="userInfo.avatar"
                                         v-if="userInfo.avatar !== ''" />
                                </div>
                            </div>
                            <div class="flexBox flexBetween lh30 myborderB">
                                <div class="flexBox-cell-50 f10">用户名</div>
                                <div class="flexBox-cell-50 tr">
                                    <input type="text" class="infoInput"
                                           v-on:change='editNickname'
                                           v-model="userInfo.nickname" />
                                </div>
                            </div>
                            <div class="flexBox flexBetween lh30">
                                <div class="flexBox-cell-50 f10">手机号</div>
                                <div class="flexBox-cell-50 tr f10 color_999">{{userInfo.mobile}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ml10 mr10 mt10">
                    <div class="myContentBox">
                        <div class="ml7 mr7">
                            <div class="flexBox flexBetween lh30 myborderB"
                                 v-on:click='toEditPassword'>
                                <div class="flexBox-cell-50 f10">修改登录密码</div>
                                <div class="flexBox-cell-50 tr color_999 f8"><span
                                        class="iconfont icon-mjiantou-copy color_999"></span></div>
                            </div>
                            <div class="flexBox flexBetween myborderB lh30">
                                <div class="flexBox-cell-50 f10">支付宝绑定</div>
                                <div class="flexBox-cell-50 tr color_999 f8"
                                     v-show="isBindAliPay">已绑定<span
                                        class="iconfont icon-mjiantou-copy color_999"></span></div>
                                <div class="flexBox-cell-50 tr color_999 f8" v-show="!isBindAliPay"
                                     v-on:click='toBindAliPay()'>去绑定<span
                                        class="iconfont icon-mjiantou-copy color_999"></span></div>
                            </div>
                            <div class="flexBox flexBetween lh30">
                                <div class="flexBox-cell-50 f10">淘宝授权</div>
                                <div class="flexBox-cell-50 tr color_999 f8"
                                     v-show="isTopAuth">已授权<span
                                        class="iconfont icon-mjiantou-copy color_999"></span>
                                </div>
                                <div class="flexBox-cell-50 tr color_999 f8" v-show="!isTopAuth"
                                     v-on:click='toTopAuth'>去授权<span
                                        class="iconfont icon-mjiantou-copy color_999"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="{'myOutBtn_damai':app.template.style === 'main','myOutBtn_damai_yellow':app.template.style === 'main_b','myOutBtn_damai_green':app.template.style === 'main_c'}"
                     v-on:click='logout'>退出登录
                </div>
            </main>
        </template>
        <template v-else>
            <main class="MainCon bottom0">
                <div class="ml10 mr10 mt10">
                    <div class="myContentBox">
                        <div class="ml7 mr7">
                            <div class="flexBox flexBetween lh40 myborderB">
                                <div class="flexBox-cell-50 f10 lh48">头像</div>
                                <div class="flexBox-cell-50 tr infoHeadimg pt5"
                                     v-on:click="uploadAvatar">
                                    <img v-bind:src="userInfo.avatar"
                                         v-if="userInfo.avatar !== ''" />
                                </div>
                            </div>
                            <div class="flexBox flexBetween lh30 myborderB">
                                <div class="flexBox-cell-50 f10">用户名</div>
                                <div class="flexBox-cell-50 tr"><input type="text" class="infoInput"
                                                                       v-on:change='editNickname'
                                                                       v-model="userInfo.nickname" />
                                </div>
                            </div>
                            <div class="flexBox flexBetween lh30">
                                <div class="flexBox-cell-50 f10">手机号</div>
                                <div class="flexBox-cell-50 tr f10 color_999">{{userInfo.mobile}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ml10 mr10 mt10">
                    <div class="myContentBox">
                        <div class="ml7 mr7">
                            <div class="flexBox flexBetween lh30 myborderB"
                                 v-on:click='toEditPassword'>
                                <div class="flexBox-cell-50 f10">修改登录密码</div>
                                <div class="flexBox-cell-50 tr color_999 f8"><span
                                        class="iconfont icon-mjiantou-copy color_999"></span></div>
                            </div>
                            <div class="flexBox flexBetween myborderB lh30">
                                <div class="flexBox-cell-50 f10">支付宝绑定</div>
                                <div class="flexBox-cell-50 tr color_999 f8"
                                     v-show="isBindAliPay">已绑定<span
                                        class="iconfont icon-mjiantou-copy color_999"></span></div>
                                <div class="flexBox-cell-50 tr color_999 f8" v-show="!isBindAliPay"
                                     v-on:click='toBindAliPay()'>去绑定<span
                                        class="iconfont icon-mjiantou-copy color_999"></span></div>
                            </div>
                            <div class="flexBox flexBetween lh30">
                                <div class="flexBox-cell-50 f10">淘宝授权</div>
                                <div class="flexBox-cell-50 tr color_999 f8"
                                     v-show="isTopAuth">已授权<span
                                        class="iconfont icon-mjiantou-copy color_999"></span></div>
                                <div class="flexBox-cell-50 tr color_999 f8" v-show="!isTopAuth"
                                     v-on:click='toTopAuth'>去授权<span
                                        class="iconfont icon-mjiantou-copy color_999"></span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="ml10 mr10 mt20 mb30">
                    <div :class="{'myBtn':app.template.style === 'main','myBtn_red':app.template.style === 'main_b','myBtn_green':app.template.style === 'main_c'}"
                         v-on:click='logout'>退出登录
                    </div>
                </div>
            </main>
        </template>

        <form id="avatarForm" enctype='multipart/form-data'>
            <input type="file" name="file" ref="uploadAvatarInput"
                   accept="image/png,image/gif,image/jpeg" class="hide"
                   v-on:change='fileChange' />
        </form>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import {appService} from '../services/app';
    import {isEmpty, isMobile} from '../libs/utils';
    import Header from '../components/Header';

    const store2 = require('store2')

    export default {
        components: {Header},
        data() {
            return {
                title: '账户设置',
                isBindAliPay: false,
                isTopAuth: false,
                userInfo: {
                    avatar: '',
                    nickname: '',
                    mobile: '',
                },
            }
        },
        computed: {
            ...mapState(['app'])
        },
        created() {
            if (!isMobile()) {
                window.location.href = window.location.origin + '/user';
            }

            this.fetchUserInfo();
            this.bindAliPayCheck();
        },
        mounted() {
            let userInfo = store2.get('userInfo');
            if (isEmpty(userInfo)) {
                this.$router.push({name: 'home'})
            }
        },
        methods: {
            ...mapActions({
                appLogout: 'logout',
            }),
            fetchUserInfo: function () {
                let self = this;

                appService.fetchUserInfo().then((res) => {
                    let {code, data} = res;
                    if (code === 1) {
                        self.userInfo = data;
                        if (!isEmpty(self.userInfo['relation_id']) && self.userInfo['relation_id'] !== '0') {
                            self.isTopAuth = true;
                        }
                    }
                });
            },
            bindAliPayCheck: function () {
                let self = this;

                appService.bindAliPayCheck().then((res) => {
                    let {code, data} = res;
                    if (code === 1) {
                        self.isBindAliPay = data;
                    }
                });
            },
            fileChange: function (e) {
                let self = this;
                let avatar = e.target.files[0];

                appService.updateProfile({avatar: avatar}).then(() => {
                    self.$nextTick(function () {
                        self.fetchUserInfo();
                    });
                });
            },
            uploadAvatar: function () {
                this.$refs.uploadAvatarInput.click();
            },
            editNickname: function () {
                let self = this;

                appService.updateProfile({nickname: this.userInfo.nickname}).then(() => {
                    self.$nextTick(function () {
                        self.fetchUserInfo();
                    });
                });
            },
            toEditPassword: function () {
                this.$router.push({name: 'edit-password'})
            },
            toBindAliPay: function () {
                this.$router.push({name: 'bind-alipay'})
            },
            toTopAuth: function () {
                appService.fetchBindTopRidUrl().then((res) => {
                    window.location.href = res.data;
                });
            },
            logout: function () {
                this.appLogout();
                this.$router.push({name: 'user'})
            }
        }
    }
</script>

<style scoped>

</style>
